import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Comp1 from "../Assets/Companies/wipro.png";
import Comp2 from "../Assets/Companies/tcs.png";
import Comp3 from "../Assets/Companies/tata.png";
import Comp4 from "../Assets/Companies/sds.png";
import Comp5 from "../Assets/Companies/samsung.png";
import Comp6 from "../Assets/Companies/sa.png";
import Comp7 from "../Assets/Companies/gh.png";
import Comp8 from "../Assets/Companies/dssad.png";
import Comp9 from "../Assets/Companies/dgdg.png";
import Comp10 from "../Assets/Companies/daikin.png";
import Comp11 from "../Assets/Companies/ashock.png";

const IndustrialConnects = () => {
  const carouselImages = [
    Comp1,
    Comp2,
    Comp3,
    Comp4,Comp5,Comp6,Comp7,Comp8,Comp10,Comp11
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    prevArrow: (
      <button className="slick-prev">
        <span className="text-2xl">&lt;</span> 
      </button>
    ),
    nextArrow: (
      <button className="slick-next">
        <span className="text-2xl">&gt;</span> 
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024, // For tablets and medium screens
        settings: {
          slidesToShow: 2, // Show 2 slides for medium screens
        },
      },
      {
        breakpoint: 768, // For mobile screens (up to 768px width)
        settings: {
          slidesToShow: 1, // Show 1 slide on mobile screens
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="pt-9 ">
      <div className="text-center">
        <h1 className="text-[#001e43] text-xl sm:text-4xl md:text-4xl font-bold leading-tight mb-3 text-center">
        Campus Placements
        </h1>
        <p className=" leading-tight text-black text-[14px] sm:text-base md:text-lg w-[70%] mx-auto font-poppins ">
        Sri Jyothi Polytechnic fosters strong industry partnerships, equipping students with the skills needed for successful campus placements.
        </p>
      </div>

      <div className="mt-12 w-[70%] mx-auto pb-12">
        <Slider {...settings}>
          {carouselImages.map((image, index) => (
            <div key={index} className="">
              <img
                src={image}
                alt={`Partner ${index + 1}`}
                className="w-[70%] mx-auto h-auto rounded-lg "
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default IndustrialConnects;
